import { showToast } from "../../../utils/styles/toastUtils";
import { postLoginApi } from "../../apis/auth/postLoginApi";
import * as types from "../ActionTypes";
import { getCurrentUserDetailsActionInitiate } from "../profile/getCurrentUserDetailsAction";

export const SignInActionStart = () => ({
  type: types.POST_LOGIN_START,
});

export const SignInActionSuccess = (data) => ({
  type: types.POST_LOGIN_SUCCESS,
  payload: data,
});

export const SignInActionError = (error) => ({
  type: types.POST_LOGIN_ERROR,
  payload: error,
});

export const SignInActioninitiate = (data, navigate) => {
  return async function (dispatch) {
    dispatch(SignInActionStart());

    try {
      const res = await postLoginApi(data);

      dispatch(SignInActionSuccess(res.data));

      if (res.data?.token) {
        try {
          localStorage.setItem("email", res.data.user.email);
          localStorage.setItem("userId", res.data.user.id);
          localStorage.setItem("token", res.data.token);
          sessionStorage.removeItem("onboardingFormData");

          localStorage.setItem("userType", res.data.user.account_type || "user");
          localStorage.setItem("isVerified", res.data.user.status || "draft");
          localStorage.setItem("onboardingCompleted", res.data.user.onboarding_completed === true ? "true" : "false");
          localStorage.setItem("phoneVerified", res.data.user.phone_verified ? "true" : "false");
          localStorage.setItem("isNewBusinessUser", res.data.user.is_new_business_user === true ? "true" : "false");
          if (res.data.user.current_step) {
            const rawStep = res.data.user.current_step;
            const stepNum = typeof rawStep === 'string' ? (parseInt(rawStep.replace(/[^0-9]/g, ''), 10) || 1) : rawStep;
            localStorage.setItem("currentStep", stepNum);
          }

          // upgrade_request_status is an object; store just the status string for fast-paint.
          const upgradeStatus = res.data.user?.upgrade_request_status?.status || "";
          localStorage.setItem("upgradeRequestStatus", upgradeStatus);
        } catch (e) {
          console.warn("localStorage write failed:", e);
        }

        if (res.data?.message) {
          showToast.success(res.data.message);
        }

        // Delay navigation by 100ms to ensure:
        // 1. Token is saved to localStorage
        // 2. API instance can read it
        // 3. /me request can succeed with Authorization header
        // Start fetching user details in the background
        setTimeout(() => {
          dispatch(getCurrentUserDetailsActionInitiate());
          // Navigate to /dashboard; DashboardRoute component will wait for feature_blocks
          // and redirect to the first available feature
          navigate("/dashboard");
        }, 100);
      }

      return { success: true, data: res.data };

    } catch (error) {
      // --- Inactive account (403 account_inactive) ---
      // API.js suppresses its toast for this; the Login component shows a modal instead.
      if (error.response?.data?.error === "account_inactive") {
        dispatch(SignInActionError("account_inactive"));
        return { success: false, deactivated: true };
      }

      // --- Unverified account (403 account_unverified) ---
      // Account exists but OTP verification is pending
      // Backend automatically sends OTP when this error is returned
      if (error.response?.data?.error === "account_unverified") {
        const msg = error.response?.data?.message || "Your account verification is pending. Please verify your OTP to continue.";
        const phoneNumber = error.response?.data?.phone_number;
        const otpSent = error.response?.data?.otp_sent;
        const otpMessage = error.response?.data?.otp_message;

        // Show OTP sent message if backend successfully sent it
        if (otpSent) {
          showToast.success(otpMessage || "OTP sent to your phone number");
        } else {
          showToast.error(otpMessage || msg);
        }

        dispatch(SignInActionError("account_unverified"));
        localStorage.setItem("auth_phone", phoneNumber);
        return { success: false, unverified: true, message: msg, phoneNumber, otpSent };
      }

      // --- 404: phone number not registered ---
      if (error.response?.status === 404) {
        const msg = error.response?.data?.error || "This phone number is not registered. Please sign up first.";
        showToast.error(msg);
        dispatch(SignInActionError(msg));
        return { success: false, message: msg };
      }

      // --- 401: wrong password ---
      if (error.response?.status === 401) {
        const msg = error.response?.data?.error || "Incorrect password. Please try again.";
        showToast.error(msg);
        dispatch(SignInActionError(msg));
        return { success: false, message: msg };
      }

      // --- 403: deleted account or other forbidden ---
      if (error.response?.status === 403) {
        const msg = error.response?.data?.error || "Access denied. Please contact support.";
        showToast.error(msg);
        dispatch(SignInActionError(msg));
        return { success: false, message: msg };
      }

      // --- Network error (no response received) ---
      if (!error.response) {
        const msg = "No response from server. Please check your connection.";
        showToast.error(msg);
        dispatch(SignInActionError(msg));
        return { success: false, message: msg };
      }

      // --- Other server errors ---
      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Login failed. Please try again.";
      showToast.error(errorMessage);
      console.error("SignInActionError", error);
      dispatch(SignInActionError(errorMessage));
      return { success: false, message: errorMessage };
    }
  };
};
